export default {
  setTeamDeployments: ({ commit }, payload) => {
    return commit("setTeamDeployments", payload);
  },
};
